module["exports"] = ["###-###-####", "(###) ###-####", "1-###-###-####", "###.###.####"];